import {useEffect, useRef, useState} from "react";
import "./app.scss";
import {Page} from "./components/";
import useVMStore from "./store";
import {SendMail, ThankPage} from "./components";

function App() {
    const _pageNames = [
        "page2",
        "page4",
        "page5",
        "page6",
        "page7",
        "page8",
        "page12",
        "page9",
        "page10",
        "page13",
        "page14",
        "page15",
    ];

    const {completedForm, validForm, editForm, setEditForm} = useVMStore();
    const SendMailRef = useRef(null);
    const [isSummaryPage, SetIsSummaryPage] = useState<boolean>(false);

    function submitForm() {
        if (isSummaryPage) {
            //@ts-ignore
            SendMailRef.current.sendForm();
        } else {
            const els = document.querySelectorAll(".title.completed");
            let error = false;
            if (els.length < 12) {
                for (let i = 0; i < _pageNames.length; i++) {
                    if (validForm.indexOf(_pageNames[i]) < 0) {
                        const el = document.querySelector("#" + _pageNames[i]);
                        if (el) {
                            el.scrollIntoView({behavior: "smooth", block: "start"});
                            el.querySelector(".title")!.classList.add("missing");
                            error = true;
                        }
                        break;
                    }
                }
            }
            if (!error) {
                SetIsSummaryPage(true);
            }
        }
    }

    useEffect(() => {
        if (editForm) {
            SetIsSummaryPage(false);
        }
    }, [editForm]);

    useEffect(() => {
        if (editForm && !isSummaryPage) {
            const el = document.querySelector("#" + editForm);
            if (el) {
                el.scrollIntoView({behavior: "smooth", block: "start"});
                setEditForm("");
            }
        }
    }, [isSummaryPage]);

    return (
        <div
            className="vm-app"
            onMouseOver={(e) => {
                e.stopPropagation();
            }}
        >
            {completedForm ? (
                <ThankPage />
            ) : (
                <>
                    <Page isSummaryPage={isSummaryPage} />
                    <footer>
                        <div className="d-flex flex-column flex-sm-row justify-content-center">
                            <button disabled={!isSummaryPage} onClick={() => SetIsSummaryPage(false)}>
                                Zurück
                            </button>
                            <button className={validForm.length === 12 ? "highlighted-btn" : ""} onClick={submitForm}>
                                {isSummaryPage ? "Senden" : "Nächste"}
                            </button>
                        </div>
                    </footer>
                    <SendMail ref={SendMailRef} />
                </>
            )}
        </div>
    );
}

export default App;
